import React, {FC} from "react";
import {makeStyles, SvgIconProps} from "@material-ui/core";
import {CheckOutlined} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    greenButton: {
        color: theme.palette.success.main
    }
}));

export const GreenCheckIcon: FC<SvgIconProps> = (props) => {
    const classes = useStyles();
    return <CheckOutlined {...props} className={classes.greenButton}/>
}
